<template>
  <div class="learning">
    <search-com @search-btn="searchBtn"></search-com>
    <div class="nav_box">
      <welfare-breadcrumb :itemBreadcrumb="itemBreadcrumb"></welfare-breadcrumb>
    </div>
    <div class="learning_box">
      <div class="page_center">
        <div class="learning_head">
          <div class="category_list" @mouseleave="handleMouseLeave">
            <div
              class="category_item"
              :class="{
                active_item: activeCategory === categoryItem.categoryName,
              }"
              v-for="categoryItem in categoryList"
              :key="categoryItem.categoryId"
              @mouseenter="handleMouseEnter(categoryItem)"
            >
              <span
                ><i class="icon_dian"></i>{{ categoryItem.categoryName }}</span
              >
              <i class="el-icon-arrow-right"></i>
            </div>
            <div
              class="category_item"
              v-if="showMore"
              @mouseenter="handleMouseEnter()"
              @click="goList"
            >
              <span><i class="icon_dian"></i>更多</span>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="subcategory_box" v-show="isShowSubCategory">
              <div class="subcategory_head">{{ activeCategory }}</div>
              <div class="subcategory_list">
                <span
                  @click="goList(subCategoryItem)"
                  v-for="subCategoryItem in subCategoryList"
                  :key="subCategoryItem.categoryId"
                >
                  {{ subCategoryItem.categoryName }}
                </span>
              </div>
            </div>
          </div>
          <el-carousel class="learn_banner">
            <el-carousel-item
              v-for="bannerItem in bannerList"
              :key="bannerItem.id"
            >
              <a :href="bannerItem.bannerHref">
                <img referrerpolicy="no-referrer" :src="bannerItem.bannerUrl" />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="course_mian">
          <div class="course_con" v-if="newLearnList && newLearnList.length">
            <div class="course_head">
              <i style="background:#F68707;"></i><span>最新课程</span>
            </div>
            <div class="course_list">
              <div
                class="course_item"
                v-for="newItem in newLearnList"
                :key="newItem.id"
              >
                <img :src="newItem.coverUrl" />
                <p class="course_title">{{ newItem.courseName }}</p>
                <div class="course_other">
                  <span class="course_price">￥{{ newItem.price }}</span>
                  <el-button
                    type="primary"
                    class="course_btn"
                    @click="goDetails(newItem)"
                    >查看详情</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="course_con" v-if="freeLearnList && freeLearnList.length">
            <div class="course_head">
              <i style="background:#FFD500;"></i><span>免费课程</span>
            </div>
            <div class="course_list">
              <div
                class="course_item"
                v-for="freeItem in freeLearnList"
                :key="freeItem.id"
              >
                <img :src="freeItem.coverUrl" />
                <p class="course_title">{{ freeItem.courseName }}</p>
                <div class="course_other">
                  <span class="course_price">￥{{ freeItem.price }}</span>
                  <el-button
                    type="primary"
                    class="course_btn"
                    @click="goDetails(freeItem)"
                    >查看详情</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="course_con"
            v-if="appointLearnList && appointLearnList.length"
          >
            <div class="course_head">
              <i style="background:#4482FF;"></i><span>金融银行</span>
            </div>
            <div class="course_list">
              <div
                class="course_item"
                v-for="appointItem in appointLearnList"
                :key="appointItem.id"
              >
                <img :src="appointItem.coverUrl" />
                <p class="course_title">{{ appointItem.courseName }}</p>
                <div class="course_other">
                  <span class="course_price">￥{{ appointItem.price }}</span>
                  <el-button
                    type="primary"
                    class="course_btn"
                    @click="goDetails(appointItem)"
                    >查看详情</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SearchCom from "@/components/welfareMallComp/SearchCom";
import WelfareBreadcrumb from "@/components/welfareMallComp/WelfareBreadcrumb";
import { mapState, mapMutations } from "vuex";
import { getBannerList } from "@/network/welfareMall_api";
import {
  getShopCategoryList,
  getShopSubCategoryList,
  getNewCourseList,
  getFreeCourseList,
} from "@/network/courselearning";
export default {
  name: "learningIndex",
  components: {
    WelfareBreadcrumb,
    SearchCom,
  },
  data() {
    return {
      itemBreadcrumb: [
        {
          name: "企业商城",
          to: "/welfareHome",
        },
        {
          name: "课程商城",
        },
      ],
      showMore: "", //显示更多
      categoryList: [], //课程分类
      isShowSubCategory: false,
      activeCategory: "", //当前显示的课程分类
      subCategoryList: [], //细分类目
      bannerList: [], //banner
      newLearnList: [], //最新课程
      freeLearnList: [], //免费课程
      appointLearnList: [], //指定课程分类下最新的课程
    };
  },
  computed: {
    // 映射
    ...mapState(["useInfo"]),
  },
  created() {
    this.getCategory(); //获取课程分类
    this.getBanner(); //获取banner
    this.getNewLearnList(); //获取最新课程
    this.getFreeLearnList(); //获取免费课程
    this.getAppointLearnList(); //获取指定分类下的课程
  },
  methods: {
    // 点击查询 search
    searchBtn(val) {
      if (!val) {
        return this.$message.info("请输入查询内容");
      }
      document.cookie = "vueRouter=" + "/welfareSearchResult";
      this.$router.push({
        name: "WelfareSearchResult",
        params: {
          value: val,
        },
      });
    },
    // 课程分类
    async getCategory() {
      let res = await getShopCategoryList();
      if (res.isSuccess) {
        let listLength = res.data.length;
        //判断课程分类长度
        if (listLength && listLength < 6) {
          this.showMore = false;
          this.categoryList = res.data.slice(0, 6);
        } else {
          this.showMore = true;
          this.categoryList = res.data.slice(0, 5);
        }
      }
    },
    //鼠标悬停事件
    handleMouseEnter(item) {
      if (item) {
        this.activeCategory = item.categoryName;
        this.getSubCategory(item.categoryId);
        this.isShowSubCategory = true;
      } else {
        this.activeCategory = "";
        this.subCategoryList = [];
        this.isShowSubCategory = false;
      }
    },
    //鼠标离开事件
    handleMouseLeave() {
      this.activeCategory = "";
      this.subCategoryList = [];
      this.isShowSubCategory = false;
    },
    // 细分类目
    async getSubCategory(parentId) {
      let params = { parentId };
      let res = await getShopSubCategoryList(params);
      if (res.isSuccess) {
        this.subCategoryList = res.data;
      }
    },
    // 获取banner
    async getBanner() {
      let params = { parentId: 14 };
      let res = await getBannerList(params);
      if (res.isSuccess) {
        let bannerData = res.data;
        this.bannerList = bannerData.filter((category) => category.isActive);
      }
    },
    //获取 最新课程
    async getNewLearnList() {
      let res = await getNewCourseList();
      if (res.isSuccess) {
        this.newLearnList = res.data;
      }
    },
    //获取 免费课程
    async getFreeLearnList() {
      let params = { limit: 4 };
      let res = await getFreeCourseList(params);
      if (res.isSuccess) {
        this.freeLearnList = res.data;
      }
    },
    //获取 最新课程
    async getAppointLearnList() {
      let params = { categoryId: 3 };
      let res = await getNewCourseList(params);
      if (res.isSuccess) {
        this.appointLearnList = res.data;
      }
    },
    // 跳转 课程列表页
    goList(item) {
      if (item) {
        this.$router.push({
          name: "learningList",
          params: { categoryId: item.fId, subCategoryId: item.categoryId },
        });
      } else {
        this.$router.push({
          name: "learningList",
        });
      }
    },
    // 跳转 课程详情页
    goDetails(item) {
      this.$router.push({
        name: "learningDetails",
        query: { courseId: item.id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page_center {
  margin: 0 auto;
  width: 1200px;
}
.learning_box {
  margin-top: 15px;
  background: #f9f9f9;
  .learning_head {
    padding-top: 20px;
    display: flex;
    .category_list {
      position: relative;
      display: inline-block;
      width: 235px;
      height: 390px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      .category_item {
        cursor: pointer;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 65px;
        &:hover {
          background: #ebf1fd;
          i {
            color: #4c80fa;
            opacity: 1;
          }
          span {
            color: #4c80fa;
          }
        }
        .icon_dian {
          margin-right: 10px;
          display: inline-block;
          width: 6px;
          height: 6px;
          background: linear-gradient(
            270deg,
            #ffffff 0%,
            #e5f3fa 0%,
            #0089cd 100%
          );
          opacity: 0.3;
          border-radius: 50%;
        }
        span {
          display: inline-flex;
          align-items: center;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          line-height: 22px;
        }
      }
      .active_item {
        background: #ebf1fd;
        i {
          color: #4c80fa;
          opacity: 1 !important;
        }
        span {
          color: #4c80fa;
        }
      }
      .subcategory_box {
        position: absolute;
        top: 0;
        left: 235px;
        z-index: 5;
        padding: 30px 40px;
        width: 732px;
        height: 390px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        border: 1px solid #e0edff;
        .subcategory_head {
          padding-bottom: 25px;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          border-bottom: 1px solid #eef0f5;
        }
        .subcategory_list {
          margin-top: 20px;
          max-height: 265px;
          overflow: hidden;
          span {
            margin-right: 40px;
            margin-bottom: 10px;
            display: inline-block;
            width: 98px;
            height: 19px;
            font-weight: 400;
            font-size: 14px;
            color: #556580;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:nth-child(5n) {
              margin-right: 0;
            }
            &:hover {
              cursor: pointer;
              color: #4c80fa;
            }
          }
        }
      }
    }
    .learn_banner {
      margin-left: 20px;
      display: inline-block;
      width: 945px;
      height: 389px;
      border-radius: 10px;
      /deep/.el-carousel__container {
        width: 945px;
        height: 389px;
      }
      a,
      img {
        display: block;
        width: 100%;
        height: 100%;
        background-size: 100%;
      }
    }
  }
  .course_mian {
    padding-bottom: 60px;
    .course_con {
      margin-top: 80px;
      .course_head {
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          width: 11px;
          height: 33px;
          border-radius: 6px;
        }
        span {
          margin-left: 15px;
          font-weight: bold;
          font-size: 30px;
          color: #3c3c3c;
        }
      }
      .course_list {
        margin-top: 60px;
        display: flex;
        justify-content: space-between;
        .course_item {
          width: 285px;
          height: 354px;
          background: #ffffff;
          border-radius: 10px 10px;
          border: 1px solid #eef0f5;
          img {
            width: 285px;
            height: 210px;
            background-size: 100%;
            border-radius: 10px 10px 0 0;
          }
          .course_title {
            margin: 20px 16px 25px;
            height: 45px;
            font-weight: 400;
            font-size: 16px;
            color: #000327;
            line-height: 24px;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .course_other {
            margin: 0 16px;
            display: flex;
            justify-content: space-between;
            .course_price {
              font-weight: 400;
              font-size: 20px;
              color: #fe6262;
            }
            .course_btn {
              padding: 0;
              width: 95px;
              height: 30px;
              color: #fff;
              border-radius: 15px;
            }
          }
        }
      }
    }
  }
}
</style>
